/*
 *
 * TermsAndConditionsDisputlessPopup
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 24-Jun-2025
 */

import { connect } from 'react-redux'
import TermsAndConditionsDisputlessPopup from './TermsAndConditionsDisputlessPopup'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(doPopup(''))
})

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TermsAndConditionsDisputlessPopup)
